import { Modal } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";
import { toast } from "react-toastify";

const QRCode = ({ showqrmodal, setShowQrModal, qrData, saleName }) => {
    const QrCodeSize = 248;
    const UsdtLogoSize = 70;
    const qrRef = useRef(null);

    console.log(qrData, 'qrData');

    // Download QR Code functionality
    const handleDownloadQR = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (!canvas) return;
        setShowQrModal(false)
        // Convert canvas to blob
        canvas.toBlob((blob) => {
            if (!blob) return;

            // Create download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = `${saleName}-qr-code.png`;
            link.href = url;
            link.click();
            // Show success alert
            toast.success('Downloading Qr code...',  {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                progress: undefined,
                theme: "colored",
            });
            // Cleanup
            URL.revokeObjectURL(url);
        });
    };

    // Share functionality for different platforms
    const shareUrl = qrData || window.location.href;
    const shareText = `Check out new sale ${saleName || ''} on Gems`;

    const socialLinks = {
        twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
        telegram: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`,
        whatsapp: `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`,
        email: `mailto:?subject=${encodeURIComponent(shareText)}&body=${encodeURIComponent(shareUrl)}`,
    };

    // Copy link to clipboard
    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            toast.info('Link copied to clipboard!');
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    };

    return (
        <Modal
            className="walletconnectmodal addteammembermodal"
            show={showqrmodal}
            onHide={() => setShowQrModal(false)}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Share QR Code
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mainqr">
                    <img src="\assets\qrcode\qrcode-bg.png" alt="img" className="img-fluid qrcode-bg" />
                    <img src="\assets\qrcode\gems-logo.svg" alt="img" className="img-fluid gems-logo" />
                    <div
                        ref={qrRef}
                        style={{ position: "relative", width: QrCodeSize, height: QrCodeSize, margin: "0 auto" }}
                    >
                        <QRCodeCanvas
                            value={qrData || "https://default-url.com"}
                            size={QrCodeSize}
                            bgColor="#0E2026"
                            fgColor="#ECF5F9"
                            level="H"
                            includeMargin
                        />
                        <svg style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            width: UsdtLogoSize,
                            height: UsdtLogoSize,
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "#fff",
                            padding: "4px",
                        }} xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71" fill="none">
                            <rect width="71" height="71" rx="4" fill="#0E2026" />
                            <rect width="71" height="71" rx="4" fill="#0E2026" />
                            <path d="M25.3638 20.7173L16.9387 29.8292V35.7391L35.5041 54.2827L54.0612 35.7491V33.3626H31.3936L32.9645 38.2897H43.5112L35.5025 46.2928L22.7811 33.5813L29.2405 26.6041H41.7645L44.5247 29.5889H53.0195V28.7039L45.6345 20.7173H25.3638Z" fill="#30F1B6" />
                        </svg>
                    </div>
                </div>

                <div className="social-parent">
                    <h6>Share with Friends</h6>
                    <div className="social-icons">
                        {/* Twitter */}
                        <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <g clipPath="url(#clip0_1849_4395)">
                                    <path d="M8.51363 1.0498H10.0574L6.68476 4.90447L10.6524 10.1498H7.54576L5.11256 6.96854L2.32843 10.1498H0.783761L4.3911 6.0268L0.584961 1.0498H3.77043L5.96983 3.9576L8.51363 1.0498ZM7.97183 9.22581H8.82723L3.30563 1.92527H2.38769L7.97183 9.22581Z" fill="#212121" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1849_4395">
                                        <rect width="11.2" height="11.2" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>

                        {/* Facebook */}
                        <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <g clipPath="url(#clip0_1849_4399)">
                                    <path d="M6.46766 11.199V6.09055H8.18167L8.43883 4.0991H6.46766V2.82785C6.46766 2.25145 6.62706 1.85865 7.45454 1.85865L8.5082 1.85822V0.0769922C8.32599 0.0533128 7.70051 -0.000976562 6.97251 -0.000976562C5.45233 -0.000976562 4.41159 0.926924 4.41159 2.63061V4.0991H2.69238V6.09055H4.41159V11.199H6.46766Z" fill="#212121" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1849_4399">
                                        <rect width="11.2" height="11.2" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>

                        {/* Telegram */}
                        <a href={socialLinks.telegram} target="_blank" rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M7.73425 4.39342C8.02049 4.09865 8.30467 3.41088 7.11197 4.24604C5.99785 5.03566 4.87615 5.8139 3.74704 6.58065C3.5751 6.6607 3.38922 6.70416 3.20057 6.70838C3.01192 6.7126 2.82439 6.67752 2.64924 6.60522C1.93363 6.38414 1.09822 6.08938 1.09822 6.08938C1.09822 6.08938 0.527807 5.72039 1.50426 5.32738C1.50426 5.32738 5.63252 3.58282 7.06427 2.9682C7.6129 2.72256 9.47402 1.93653 9.47402 1.93653C9.47402 1.93653 10.3333 1.5921 10.2617 2.4278C10.2379 2.77169 10.047 3.97637 9.8562 5.27825C9.56944 7.12105 9.25934 9.13633 9.25934 9.13633C9.25934 9.13633 9.21163 9.70129 8.80611 9.79955C8.37203 9.79196 7.95261 9.63646 7.61342 9.3574C7.51801 9.28371 5.82387 8.17782 5.20315 7.63742C5.13999 7.59336 5.0887 7.53361 5.05401 7.46366C5.01937 7.39371 5.00242 7.31585 5.0048 7.23735C5.00719 7.15886 5.02881 7.08228 5.06765 7.01468C5.10649 6.94713 5.1613 6.89074 5.227 6.85085C6.07838 6.04874 6.91425 5.22944 7.73425 4.39342Z" fill="#212121" />
                            </svg>
                        </a>

                        {/* WhatsApp */}
                        <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <g clipPath="url(#clip0_1849_4406)">
                                    <path d="M5.5993 0.447266C2.75853 0.447266 0.447299 2.7585 0.447299 5.59927C0.447299 6.48631 0.676451 7.35856 1.11101 8.12823L0.455587 10.4668C0.434083 10.5436 0.454915 10.626 0.510467 10.6832C0.553251 10.7273 0.611491 10.7513 0.671299 10.7513C0.689219 10.7513 0.707363 10.749 0.725059 10.7448L3.16576 10.1402C3.91101 10.5403 4.75034 10.7513 5.5993 10.7513C8.44007 10.7513 10.7513 8.44003 10.7513 5.59927C10.7513 2.7585 8.44007 0.447266 5.5993 0.447266ZM8.19098 7.41725C8.08077 7.72234 7.55213 8.00077 7.29811 8.03818C7.07008 8.07155 6.78157 8.08589 6.46483 7.98643C6.27287 7.92595 6.02647 7.84576 5.71085 7.71114C4.3841 7.14531 3.51767 5.82618 3.45136 5.73904C3.38528 5.65191 2.9113 5.03098 2.9113 4.38832C2.9113 3.74567 3.2529 3.4296 3.37431 3.29879C3.49571 3.16797 3.63885 3.13527 3.72711 3.13527C3.81536 3.13527 3.90339 3.13639 3.98067 3.13997C4.06199 3.144 4.17107 3.10928 4.27837 3.36419C4.38858 3.62583 4.65312 4.26848 4.68583 4.33411C4.71898 4.39952 4.74093 4.47591 4.69703 4.56304C4.65312 4.65018 4.63117 4.70461 4.56487 4.78099C4.49856 4.85738 4.42599 4.95123 4.3664 5.00992C4.3001 5.07511 4.23133 5.14567 4.30839 5.27648C4.38544 5.4073 4.65088 5.83491 5.04423 6.18122C5.54935 6.62608 5.97562 6.76407 6.10778 6.82947C6.23994 6.89488 6.31722 6.88391 6.39427 6.79677C6.47133 6.70941 6.7249 6.4153 6.81293 6.28471C6.90096 6.15411 6.98922 6.17562 7.11063 6.2193C7.23203 6.26275 7.88231 6.57859 8.01447 6.644C8.14663 6.70941 8.23488 6.74211 8.26803 6.79655C8.30119 6.85075 8.30119 7.11239 8.19098 7.41725Z" fill="#212121" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1849_4406">
                                        <rect width="11.2" height="11.2" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>

                        {/* Email */}
                        <a href={socialLinks.email} target="_blank" rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <g clipPath="url(#clip0_1849_4409)">
                                    <path d="M6.53601 6.86164C6.25737 7.0474 5.9337 7.1456 5.6 7.1456C5.26632 7.1456 4.94266 7.0474 4.66401 6.86164L0.0745719 3.80192C0.0491094 3.78494 0.0243031 3.76725 0 3.74905V8.76273C0 9.33756 0.466484 9.79376 1.03103 9.79376H10.1689C10.7438 9.79376 11.2 9.32728 11.2 8.76273V3.74902C11.1756 3.76727 11.1508 3.78501 11.1253 3.802L6.53601 6.86164Z" fill="#212121" />
                                    <path d="M0.438594 3.2567L5.02803 6.31644C5.20177 6.43227 5.40087 6.49017 5.59998 6.49017C5.79911 6.49017 5.99823 6.43225 6.17197 6.31644L10.7614 3.2567C11.036 3.07372 11.2 2.76747 11.2 2.43693C11.2 1.8686 10.7376 1.40625 10.1693 1.40625H1.03068C0.462372 1.40627 0 1.86862 0 2.43748C0 2.76747 0.163975 3.07372 0.438594 3.2567Z" fill="#212121" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1849_4409">
                                        <rect width="11.2" height="11.2" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>

                        {/* Copy Link */}
                        <a href="#" onClick={(e) => { e.preventDefault(); handleCopyLink(); }} style={{ cursor: 'pointer' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <g clipPath="url(#clip0_1849_4413)">
                                    <path d="M6.83381 4.36384C6.70114 4.23038 6.55403 4.11208 6.39523 4.0111C5.9746 3.74176 5.48561 3.59864 4.98614 3.59864C4.29289 3.59735 3.62781 3.87279 3.13847 4.36384L0.764496 6.73967C0.275984 7.22913 0.00141452 7.89228 0.000977103 8.5838C5.85183e-05 10.0269 1.16911 11.1974 2.61216 11.1983C3.30434 11.2007 3.96881 10.9266 4.45797 10.4369L6.41762 8.47722C6.45323 8.44192 6.47311 8.39376 6.47283 8.34363C6.47223 8.24055 6.38818 8.15749 6.28511 8.15808H6.21046C5.80103 8.15952 5.39526 8.08089 5.01601 7.92666C4.94614 7.8979 4.86583 7.91413 4.81259 7.96771L3.4035 9.37866C2.96595 9.81621 2.25654 9.81621 1.81899 9.37866C1.38144 8.9411 1.38144 8.2317 1.81899 7.79414L4.2023 5.41271C4.6395 4.97606 5.34776 4.97606 5.78496 5.41271C6.07961 5.69001 6.5392 5.69001 6.83383 5.41271C6.96059 5.28584 7.03745 5.11756 7.05033 4.93866C7.06396 4.72487 6.98511 4.51549 6.83381 4.36384Z" fill="#212121" />
                                    <path d="M10.4357 0.764352C9.41528 -0.256086 7.76082 -0.256086 6.74038 0.764352L4.78259 2.72026C4.72883 2.77428 4.71333 2.85553 4.7434 2.92556C4.77312 2.99579 4.84258 3.04087 4.91883 3.0394H4.98787C5.39682 3.03866 5.80194 3.1179 6.18046 3.2727C6.25034 3.30146 6.33065 3.28523 6.38388 3.23165L7.78923 1.82816C8.22678 1.39061 8.93619 1.39061 9.37374 1.82816C9.8113 2.26571 9.8113 2.97512 9.37374 3.41268L7.62312 5.16142L7.60818 5.17822L6.99603 5.78665C6.55883 6.22331 5.85058 6.22331 5.41338 5.78665C5.11873 5.50935 4.65913 5.50935 4.3645 5.78665C4.23693 5.91449 4.16001 6.08423 4.148 6.26442C4.13436 6.47821 4.2132 6.68758 4.3645 6.83926C4.58053 7.0562 4.83327 7.23311 5.11103 7.36183C5.15022 7.38048 5.18942 7.39542 5.22861 7.41222C5.2678 7.42901 5.30885 7.44207 5.34805 7.45701C5.38724 7.47195 5.42829 7.485 5.46748 7.4962L5.57761 7.52606C5.65225 7.54471 5.72692 7.55965 5.80342 7.57271C5.89559 7.5864 5.98841 7.59512 6.08152 7.59884H6.21215H6.22335L6.33533 7.58578C6.37638 7.58393 6.41931 7.57459 6.46785 7.57459H6.53129L6.66007 7.55593L6.7198 7.54473L6.82804 7.52234H6.84858C7.30702 7.40719 7.72563 7.16982 8.05982 6.83552L10.4357 4.45969C11.4562 3.43925 11.4562 1.78479 10.4357 0.764352Z" fill="#212121" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1849_4413">
                                        <rect width="11.2" height="11.2" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>
                    </div>
                </div>

                <div className="modalbtns modalbtnsqr mt-4">
                    <button className="whitebtn" onClick={() => setShowQrModal(false)}>
                        Cancel
                    </button>
                    <button
                        className="greybtn"
                        style={{ gap: "13px" }}
                        onClick={handleDownloadQR}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M5.25 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V5.25C2.25 5.66421 2.58579 6 3 6H5.25C5.66421 6 6 5.66421 6 5.25V3C6 2.58579 5.66421 2.25 5.25 2.25Z" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M15 2.25H12.75C12.3358 2.25 12 2.58579 12 3V5.25C12 5.66421 12.3358 6 12.75 6H15C15.4142 6 15.75 5.66421 15.75 5.25V3C15.75 2.58579 15.4142 2.25 15 2.25Z" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.25 12H3C2.58579 12 2.25 12.3358 2.25 12.75V15C2.25 15.4142 2.58579 15.75 3 15.75H5.25C5.66421 15.75 6 15.4142 6 15V12.75C6 12.3358 5.66421 12 5.25 12Z" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M15.75 12H13.5C13.1022 12 12.7206 12.158 12.4393 12.4393C12.158 12.7206 12 13.1022 12 13.5V15.75" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M15.75 15.75V15.76" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 5.25V7.5C9 7.89782 8.84196 8.27935 8.56066 8.56066C8.27935 8.84196 7.89782 9 7.5 9H5.25" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2.25 9H2.26" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 2.25H9.01" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 12V12.01" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 9H12.75" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M15.75 9V9.01" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 15.75V15" stroke="#E2E9EC" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                        </svg> Download QR Code
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default QRCode;